import './spinner.scss';

const Spinner = () => {
  return <div className="spinner"></div>;
};
export default Spinner;
